import {
  CHECK_PROMO_CODE_REQUEST,
  CHECK_PROMO_CODE_SUCCESS,
  CHECK_PROMO_CODE_FAILURE,
  CHECK_PROMO_CODE_RESET,
  CHECK_PROMO_CODE_INITIAL,
} from '../types';

const initialState = {
  status: 'initial',
  message: '',
  info: {
    code: '',
    amount: null,
    discountName: null,
    minAmount: null,
    type: null,
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_PROMO_CODE_REQUEST:
      return {
        ...state,
        status: 'fetching',
      };
    case CHECK_PROMO_CODE_RESET:
      return {
        status: 'initial',
        message: '',
        info: {
          code: '',
          amount: null,
          discountName: null,
          minAmount: null,
          type: null,
        }
      };
    case CHECK_PROMO_CODE_INITIAL:
    return {
      status: 'initial',
      message: '',
      info: {
        code: '',
        amount: null,
        discountName: null,
        minAmount: null,
        type: null,
      }
    };
    case CHECK_PROMO_CODE_SUCCESS:
      return {
        ...state,
        status: 'success',
        ...action.payload,
      };

    case CHECK_PROMO_CODE_FAILURE:
      return {
        ...state,
        status: 'fail',
        message: action.payload,
      };

    default:
      return state;
  }
};
